export function canChangeAppTheme() {
  return __DEV__;
}
